<svg
  #svgElement
  [attr.aria-label]="ariaLabel"
  [attr.width]="getIconSize(size) + safeArea"
  [attr.height]="getIconSize(size) + safeArea"
  [attr.viewBox]="getViewBox()"
  fill="currentColor"
  xmlns="http://www.w3.org/2000/svg"
>
  <title>{{ variant }} icon</title>

  <!-- Dynamic variant component container -->
  <ng-container #variantContainer></ng-container>
</svg>
<div *ngIf="badgeCount !== undefined">
  <!-- Badge component will need to be implemented -->
  <!-- <app-badge [aria-label]="ariaLabel + ' badge'" [top]="-3" [right]="-3" [count]="badgeCount"></app-badge> -->
</div>